export const DeclarativeElementMarkerSymbol = Symbol('this-is-an-element-vir-declarative-element');
